<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">
		<b-form @submit="submitForm" class="mb-3">
            <div class="pull-right">
                <b-btn v-if="mode == 'edit'"
                    type="submit"
                    variant="primary"
                    v-b-tooltip.hover
                    title="Opslaan"
                >
                    <i class="fa fa-fw fa-save"></i>
                </b-btn>

                <b-btn v-if="mode == 'add'"
                    type="submit"
                    variant="primary"
                    v-b-tooltip.hover
                    :title="$t('tag.add')"
                >
                    <i class="fa fa-fw fa-save"></i>
                </b-btn>

                <b-btn variant="outline-secondary"
                    v-b-tooltip.hover
                    title="Terug"
                    exact
                    :to="{ name: 'tagList' }"
                >
                    <i class="fa fa-fw fa-reply"></i>
                </b-btn>
            </div>

			<h1 class="display-4"
			    v-if="mode == 'edit'">{{ $t('tag.edit') }}</h1>
			<h1 class="display-4"
			    v-if="mode == 'add'">{{ $t('tag.add') }}</h1>
			<h2 v-if="!isFetching">{{ form.name ? form.name : 'Tag Naam' }}</h2>

			<partial-loader :loading="isFetching"></partial-loader>

			<div v-if="!isFetching">

				<b-alert v-if="formError"
				         show
				         variant="warning">
					<span v-for="errors in formError.errors">
							<span v-for="error in errors">{{ error }}<br /></span>
					</span>
				</b-alert>

				<div class="row">
                    <div class="col-6">
						<b-form-group label="Naam:">
                            <b-form-input type="text"
                                        autocomplete="off"
                                        v-model="form.name">
                            </b-form-input>
						</b-form-group>
                    </div>
				</div>

        <div class="row mb-2">
          <div class="col-6">
            <b-form-group label="Onderdeel van:">
                <multiselect
                  v-model="belongsToArray"
                  tag-placeholder="Zoek bijbehorende tag"
                  placeholder="Voeg een tag toe"
                  label="name"
                  track-by="name"
                  :options="tags.filter(el => el.id != tag.id)"
                  :loading="isFetchingTags"
                  :close-on-select="false"
                  :multiple="true"
                  :taggable="true"
                />
            </b-form-group>
          </div>
        </div>

				<b-form-checkbox v-model="form.hidden"
								 value="1"
								 unchecked-value="0">
								 {{ $t('tag.hiddenTag') }}
				</b-form-checkbox>
			</div>

		</b-form>

	</div>

</div>
</template>

<style>
</style>


<script>
import { isNil, pick, forOwn } from 'lodash';
import TagService from '@/services/tag-service';
import PartialLoader from '@/components/elements/PartialLoader';
import { replaceEmptyByNull } from '@/helpers/object-helper';
import { flashSuccess } from '@/helpers/flash-message-helper';
import Multiselect from 'vue-multiselect';
import { mapGetters as mapGlobalGetters, mapActions } from 'vuex';

export default {
	components: {
    PartialLoader,
    Multiselect
	},
	data() {
		return {
			isFetching: false,
			formError: false,
			mode: 'add',
      tag: {},
      belongsToArray: [],
			form: {
				name: '',
        hidden: false,
        belongs_to: false,
      },
		}
  },
  computed: {
    ...mapGlobalGetters([
			'tags',
			'isFetchingTags',
		]),
  },
	watch: {
		tag: function(value) {
			this.form = pick(value, [
				'name',
        'hidden',
            ]);
		},
	},
	methods: {
    ...mapActions([
      'fetchTags'
    ]),
		async fetchTag(tagId) {
      this.isFetching = true;

      try {
        const response = await TagService.getOne(tagId);
        this.tag = response;

        this.belongsToArray = this.tags.filter(tag => this.tag.belongs_to.includes(tag.id));
        this.isFetching = false;
      }
      catch (error) {
        this.isFetching = false;
        this.error = error.message;
      }
		},
		async submitForm(event) {
			this.isFetching = true;
      event.preventDefault();

      this.form.belongs_to = this.belongsToArray ? this.belongsToArray.map(el => el.id) : [];

      // const post = replaceEmptyByNull(this.form);
      const post = this.form;

			if (this.mode == 'add') {
        try {
          await TagService.create(post);
          flashSuccess(this.$t('tag.createSuccess'), true);
          this.$router.push({ name: 'tagList' });
        }
        catch (error) {
          this.isFetching = false;
					this.formError = error.response.data
        }
      } else {
        try {
					await TagService.update(this.$route.params.tagId, post);
          flashSuccess(this.$t('tag.updateSuccess'), true);
					this.$router.push({ name: 'tagList' });
        }
        catch (error) {
          this.isFetching = false;
					this.formError = error.response.data;
        }
			}
		}
  },
  async created() {
    await this.fetchTags();
  },
	mounted() {
		// check if item id exists otherwise add :)
		if (!isNil(this.$route.params.tagId)) {
			this.mode = 'edit';
			this.fetchTag(this.$route.params.tagId);
		}
	}
}
</script>



// WEBPACK FOOTER //
// TagForm.vue?7463e5c1